// Pure phone tiering ('high' | 'low' | null = unknown); inputs are gathered in src/platform/deviceTier.js.

// Flagship: Adreno 64x/73x+, Mali-G76+/G7xx+, Immortalis, Xclipse; any other named GPU is budget.
export function gpuTier(renderer) {
  if (!renderer) return null;
  const adreno = /Adreno\D*(\d{3})/i.exec(renderer);
  if (adreno) {
    const n = Number(adreno[1]);
    return n >= 730 || (n >= 640 && n < 700) ? 'high' : 'low';
  }
  if (/Immortalis|Xclipse/i.test(renderer)) return 'high';
  const mali = /Mali-G(\d+)/i.exec(renderer);
  if (mali) {
    const n = Number(mali[1]);
    return (n >= 76 && n < 100) || n >= 700 ? 'high' : 'low';
  }
  if (/Mali|PowerVR|IMG/i.test(renderer)) return 'low';
  return null;
}

// iOS reports "Apple GPU", so iPhones go by model: iPhone10,x (8 / X) and older are budget.
export function appleModelTier(model) {
  const m = /^iPhone(\d+),/.exec(model ?? '');
  if (!m) return null;
  return Number(m[1]) <= 10 ? 'low' : 'high';
}

export function deviceTier({ gpu, model, deviceMemory } = {}) {
  // Under 4 GB, VSM's extra render targets crowd out textures whatever the GPU.
  if (Number.isFinite(deviceMemory) && deviceMemory < 4) return 'low';
  return appleModelTier(model) ?? gpuTier(gpu);
}

// Flagship phones render like desktop; an unknown tier keeps the platform rule (VSM on Apple, contact elsewhere).
export function qualityProfile({ tier, isMobile, isApple }) {
  const desktopClass = !isMobile || tier === 'high';
  return {
    pixelRatio: desktopClass ? 2 : 1.5,
    reduced: !desktopClass,
    shadowQuality: (tier ?? (isApple ? 'high' : 'low')) === 'high' ? 'vsm' : 'contact',
  };
}
